<template>
  <v-container fluid grid-list-md pa-3>
    <v-layout row wrap>
      <v-flex xs12 lg12 md12 sm12>
        <v-card color="rgb(220,220,220, 0.5)">
          <v-card-title><b>Name(s) of guests:</b></v-card-title>
        </v-card>
        <v-card tile flat>
          <v-card-title>{{namesAttending.names}}</v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs12 lg12 md12 sm12>
        <v-card color="rgb(220,220,220, 0.5)">
          <v-card-title><b>Number of guests:</b></v-card-title>
        </v-card>
        <v-card tile flat>
          <v-card-title>{{namesAttending.number_of_people}}</v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs12 lg12 md12 sm12>
        <v-card color="rgb(220,220,220, 0.5)">
          <v-card-title><b>Attending?</b></v-card-title>
        </v-card>
        <v-card tile flat v-if="namesAttending.accepts_rejects=='accepts'">
          <v-card-title>Yes!</v-card-title>
        </v-card>
        <v-card tile flat v-if="namesAttending.accepts_rejects=='rejects'">
          <v-card-title>No</v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs12 lg12 md12 sm12 v-if="beef.selected">
        <v-card color="rgb(220,220,220, 0.5)">
          <v-card-title><b>Number of beef meals for guests:</b></v-card-title>
        </v-card>
        <v-card tile flat>
          <v-card-title>{{beef.count}}</v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs12 lg12 md12 sm12 v-if="chicken.selected">
        <v-card color="rgb(220,220,220, 0.5)">
          <v-card-title><b>Number of chicken meals for guests:</b></v-card-title>
        </v-card>
        <v-card tile flat>
          <v-card-title>{{chicken.count}}</v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs12 lg12 md12 sm12 v-if="other.selected">
        <v-card color="rgb(220,220,220, 0.5)">
          <v-card-title><b>Number of vegitarian or gluten free meals for guests:</b></v-card-title>
        </v-card>
        <v-card tile flat>
          <v-card-title>{{other.count}}</v-card-title>
        </v-card>
      </v-flex>
      <v-flex xs12 lg12 md12 sm12 v-if="kids.selected">
        <v-card color="rgb(220,220,220, 0.5)">
          <v-card-title><b>Number of kids meals for guests:</b></v-card-title>
        </v-card>
        <v-card tile flat>
          <v-card-title>{{kids.count}}</v-card-title>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

export default {
  name: 'InviteResponseSummary',
  props: {
    namesAttending: {
      type: Object,
      required: true,
    },
    beef: {
      type: Object,
      required: true,
    },
    chicken: {
      type: Object,
      required: true,
    },
    fish: {
      type: Object,
      required: true,
    },
    other: {
      type: Object,
      required: true,
    },
    kids: {
      type: Object,
      required: true,
    },
  },
};

</script>

<style scoped></style>
